<template>
  <div>
    <v-card flat tile class="lighten-1 text-xs-center">
      <v-card-text>
        <v-container grid-list-md text-xs-left>
          <v-layout row wrap>
            <v-flex xs12 md12 lg12>
              <v-expansion-panel class="my-4">
                <v-expansion-panel-content v-for="item in hire.data" :key="item.id" class="conteact-zone my-4 wow fadeInUp" :style="{ padding: device==='desktop' ? '30px 20px' : '5px' }">
                  <v-layout row wrap slot="header">
                    <v-flex xs3 md3 lg3 v-if="device === 'desktop'">
                      <img src="../../public/images/contact/contact_target.png" style="width: 130px">
                    </v-flex>
                    <v-flex :class="device==='desktop' ? 'xs5 md5 lg5' : 'xs8 md8 lg8'">
                      <div class="my-4" :class="device==='desktop' ? 'display-1' : 'headline'">{{ item.title }}</div>
                      <div :class="device==='desktop' ? 'title' : 'subheading'">{{ item.sub_title }}</div>
                    </v-flex>
                    <v-flex xs4 md4 lg4 text-xs-right>
                      <img src="../../public/images/logo.png" :style="{ width: device === 'desktop' ?  '180px' : '100px'}">
                    </v-flex>
                  </v-layout>
                  <v-card>
                    <v-card-text>
                      <div class="subheading" v-html="item.content">{{ item.content }}</div>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs4 md4 lg4 text-xs-right>
              <div class="mr-2">
                <img class="wow fadeInLeft" style="width: 45px; margin: 0 10px 0 0;" :src="require('../../public/images/contact/contact_phone.png')" />
              </div>
              <div class="mt-3 mr-2">
                <img class="wow fadeInLeft" style="width: 45px; margin: 0 10px 0 0;" :src="require('../../public/images/contact/contact_address.png')" />
              </div>
            </v-flex>
            <v-flex xs7 md7 lg7>
              <v-layout row wrap class="wow fadeInUp">
                <v-flex xs6 md3 lg3>
                  <div class="body-2">总机：</div>
                  <div>+8621-58888566</div>
                </v-flex>
                <v-flex xs6 md6 lg6>
                  <div class="body-2">传真：</div>
                  <div>+8621-58883586</div>
                </v-flex>
              </v-layout>
              <!-- <div class="body-2 mt-4">邮箱</div>
              <div>xxxx@gmail.com</div> -->
              <div class="body-2 mt-4 wow fadeInUp">地址Address：</div>
              <div class="wow fadeInUp">上海市静安区静安区南京西路819号3楼133室(邮编: 200041)</div>
              <div class="wow fadeInUp">Room03-133, No.819 West Nanjing Road, Jing'an District, Shanghai, China(200041)</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      show: false,
      device: 'desktop'
    }
  },
  created() {
    this.fetchData()

    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  },
  computed: mapGetters({
    hire: 'hire'
  }),
  methods: {
    fetchData() {
      this.$store.dispatch('GetHireData')
    }
  }
}
</script>

<style lang="scss">
.v-expansion-panel__header__icon {
  i {
    font-size: 60px;
    margin-top: 62px;
    width: 0;
  }
}
</style>
